<template>
  <div class="container">
    <h1 class="mb-4">{{ contract.name }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details"><fai icon="info"/>
              &nbsp;Generales
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#beneficiaries"><fai icon="users"/>
              &nbsp;Coacreedores
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#attachments"><fai icon="credit-card"/>
              &nbsp;Anexos
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="contract.id">
            <div class="row">
              <div class="col-sm-4">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-4 text-right" v-if="contract.parent_folio">
                <h5 class="m--font-info">Folio Anterior: {{ contract.parent_folio }} </h5>
              </div>
              <div class="col-sm-4 text-right" v-if="contract.attachments.length == 0">
                <button class="btn btn-info" @click="goToEdit">
                  <fai :icon="['far','edit']"/> Editar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                <h5>Acreedor</h5>
                <span>{{ contract.investor_name }}</span>
              </div>
              <div class="col-sm-4">
                <h5>Folio</h5>
                <span>{{ contract.folio }}</span>
              </div>
              <div class="col-sm-4">
                <h5>Fecha de inicio</h5>
                <span>{{ contract.date_init }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                <h5>Tasa de interés</h5>
                <span>{{ contract.interest_rate }} %</span>
              </div>
              <div class="col-sm-4">
                <h5>Tipo de Tasa</h5>
                <span>{{ contract.rate_type }} </span>
              </div>
              <div class="col-sm-4">
                <h5>Frecuencia de pago</h5>
                <span>{{ contract.frequency }}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Dia de corte</h5>
                  <span>{{ contract.cut_day }}</span>
              </div>
              <div class="col-sm-4">
                <h5>Tipo</h5>
                <span>{{ contract.type }}</span>
              </div>
              <div class="col-sm-4" v-if="contract.contract_type_id !== 2">
                <h5>Método de Pago</h5>
                <span>{{ contract.payment_method }}</span>
              </div>
            </div>
            <hr class="mt-4" v-if="contract.contract_type_id == 2"/>
            <div class="row" v-if="contract.contract_type_id == 2">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Desglose de Tasa Dividida</h4>
              </div>
            </div>
            <div class="row mt-4" v-if="contract.contract_type_id == 2">
              <div class="col-sm-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Método de Pago</th>
                      <th scope="col">Tasa de Interés</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rate in contract.rates" :key="rate.payment_method_id">
                      <td>{{ rate.payment_method }}</td>
                      <td>{{ (rate.interest_rate).toFixed(2) }} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Contrato</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <span>Seleccionar Firma </span>
                <select name="signed_by" class="form-control" @change="signature">
                  <option>Armando de Jesús Muraira Sauceda</option>
                  <option>Juliana Guadalupe Ornelas Alonso</option>
                  <option>Mauricio Robles Pérez</option>
                </select>
                <br />
                <button class="btn btn-primary" @click="downloadContract">Descargar contrato</button>
              </div>
              <div class="col-sm-6">
                <h5>Subir contrato firmado</h5>
                <vue-dropzone
                  ref="contractDropzone"
                  @vdropzone-success="successDropzone"
                  id="dropzone"
                  :options="dropzoneOptions">
                </vue-dropzone>
              </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Registro</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                <h5>Registrado por</h5>
                <span>{{ contract.creator_name }}</span>
              </div>
              <div class="col-sm-4">
                <h5>Fecha de registro en el sistema</h5>
                <span>{{ contract.created_at }}</span>
              </div>
            </div>
          </div>
          <!--end: Details -->
          <!--begin: Beneficiaries -->
          <div id="beneficiaries" class="tab-pane fade" role="tabpanel" v-if="contract.id">
            <sys-table :headers="beneficiary_headers"
            :items="beneficiary"
            title="Coacreedores"
            create_route="beneficiary_create"
            error_message="No se encontraron coacreedores"
            update_route="beneficiary_update"
            :update_route_params="{ type: 'contract', contract_id: contract.id }"/>
          </div>
          <!--end: Beneficiaries -->
          <!--begin: Attachments -->
          <div id="attachments" class="tab-pane fade" role="tabpanel" v-if="contract.id">
            <sys-table :headers="attachments_headers" :items="attachments" title="Anexos" :detail_route="attachment_detail_route" error_message="No se encontraron anexos"/>
          </div>
          <!--end: Attachments -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contractsService from '@/services/contracts'
import SysTable from '@/components/shared/Table'
import formatCurrency from '@/filters/formatCurrency'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import apiConfig from '@/services/api-config'
import store from '@/store'

export default {
  name: 'ContractDetail',

  props: {
    contract_file: { type: Array }
  },

  components: { SysTable, vueDropzone: vue2Dropzone },

  data () {
    return {
      contract: {},
      signed_by: 'Armando de Jesús Muraira Sauceda',
      attachment_detail_route: 'attachment',
      attachments_headers: [
        { text: 'Anexo', value: 'attachment_id' },
        { text: 'Folio de pagaré', value: 'promissory_folio' },
        { text: 'Fecha de inicio', value: 'date_init' },
        { text: 'Fecha de fin', value: 'date_expire' },
        { text: 'Monto', value: 'amount', filter: formatCurrency },
        { text: 'Estatus', value: 'status' }
      ],
      attachments: [],
      beneficiary_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'name' },
        { text: 'Correo', value: 'email' },
        { text: 'Teléfono', value: 'telephone' },
        { text: 'Porcentaje', value: 'percentage' },
        { text: 'Cuentahabiente', value: 'holder' },
        { text: 'Cuenta', value: 'account' },
        { text: 'Clabe', value: 'clabe' },
        { text: 'C. P.', value: 'zip' }
      ],
      beneficiary: [],
      dropzoneOptions: {
        url: `${apiConfig.apiUrl}/contract/${this.$route.params.id}/document`,
        headers: {
          Authorization: store.getters.getToken
        },
        maxFiles: 1
      }
    }
  },
  created: function () {
    const id = this.$route.params.id
    let element = this.$store.getters.getSelectedElement

    if (element.type === 'contract' && element.data.id === id) this.contract = element.data
    else {
      contractsService.getById(id).then(res => {
        this.contract = res.data
        this.attachments = this.contract.attachments
        this.beneficiary = this.contract.beneficiaries
      })
    }
  },
  methods: {
    successDropzone (file, response) {
      this.$refs.contractDropzone.removeAllFiles()
      this.contract.file_url = response.file_url
    },
    signature (e) {
      if (e.target.options.selectedIndex > -1) {
        this.signed_by = e.target.options[e.target.options.selectedIndex].text
      }
    },
    downloadContract () {
      let signature = this.signed_by
      let params = {signature}
      const id = this.$route.params.id
      contractsService.getFile(id, params)
        .then(response => {
          window.open(response, '_blank')
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    goToEdit () {
      this.$router.push({ name: 'contract_update' })
    }
  }
}
</script>
<style scoped>
.download-card {
    display: flex;
    margin: 10px 0;
}

.remove{
  color: red;
}

.download-details {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractDetail.vue